export default __webpack_public_path__ + "static/media/clarification-no-data.40bc142f.png";